export { default } from '../../src/features/onboarding/screens/OnboardingScreen'
